import { createReducer } from '@reduxjs/toolkit';
import { FluxAction } from '@saucelabs/sl-util-redux';

import { SESSION_EXPIRY_WARNING_START_TIME_S, SESSION_INACTIVE_REASONS } from '../../constants';
import { MOBILE_SESSION_CREATE } from '../../types';
import types from './types';

interface RdcSessionState {
  readonly session: {
    readonly sessionClosedReason: '' | keyof typeof SESSION_INACTIVE_REASONS;
    readonly secondsLeft: number;
  }
}

const initialState: RdcSessionState = {
  session: {
    sessionClosedReason: '',
    secondsLeft: SESSION_EXPIRY_WARNING_START_TIME_S + 1, // non-null value due to packages/web-ui/src/utils.js createMerge() to reset the remaining time of RDC session
  },
};

const rdcSessionReducer = createReducer(initialState, (builder) => {
  builder.addCase(MOBILE_SESSION_CREATE.REQUEST, (draft) => {
    draft.session = initialState.session;
  });
  builder.addCase(types.RDC_SECONDS_LEFT_UPDATE, (draft, { payload }: FluxAction) => {
    draft.session.secondsLeft = payload;
  });
  builder.addCase(types.SET_SESSION_CLOSED_REASON, (draft, { payload }: FluxAction) => {
    draft.session.sessionClosedReason = payload;
  });
});

export default rdcSessionReducer;
export { initialState, RdcSessionState };
